// index.ts
import { bearing } from "@turf/bearing";
import { bearingToAzimuth, isObject } from "@turf/helpers";
import { rhumbBearing } from "@turf/rhumb-bearing";
function angle(startPoint, midPoint, endPoint, options = {}) {
  if (!isObject(options)) {
    throw new Error("options is invalid");
  }
  if (!startPoint) {
    throw new Error("startPoint is required");
  }
  if (!midPoint) {
    throw new Error("midPoint is required");
  }
  if (!endPoint) {
    throw new Error("endPoint is required");
  }
  const A = startPoint;
  const O = midPoint;
  const B = endPoint;
  const azimuthAO = bearingToAzimuth(
    options.mercator !== true ? bearing(A, O) : rhumbBearing(A, O)
  );
  const azimuthBO = bearingToAzimuth(
    options.mercator !== true ? bearing(B, O) : rhumbBearing(B, O)
  );
  const angleAO = Math.abs(azimuthAO - azimuthBO);
  if (options.explementary === true) {
    return 360 - angleAO;
  }
  return angleAO;
}
var turf_angle_default = angle;
export {
  angle,
  turf_angle_default as default
};
//# sourceMappingURL=index.js.map